module.exports = __webpack_public_path__ + "static/media/Nina Phan.c86a6b5e.png";